// Copyright Tharsis Labs Ltd.(Evmos)
// SPDX-License-Identifier:LGPL-3.0-only

// @generated by protoc-gen-es v1.2.0
// @generated from file evmos/revenue/v1/genesis.proto (package evmos.revenue.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Revenue } from "./revenue_pb.js";

/**
 * GenesisState defines the module's genesis state.
 *
 * @generated from message evmos.revenue.v1.GenesisState
 */
export const GenesisState = proto3.makeMessageType(
  "evmos.revenue.v1.GenesisState",
  () => [
    { no: 1, name: "params", kind: "message", T: Params },
    { no: 2, name: "revenues", kind: "message", T: Revenue, repeated: true },
  ],
);

/**
 * Params defines the revenue module params
 *
 * @generated from message evmos.revenue.v1.Params
 */
export const Params = proto3.makeMessageType(
  "evmos.revenue.v1.Params",
  () => [
    { no: 1, name: "enable_revenue", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "developer_shares", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "addr_derivation_cost_create", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

